import {
  SEAT_STATUS,
  GENERAL_SEAT_COUNT_THRESHOLDS,
  NOT_GENERAL_SEAT_COUNT_THRESHOLDS,
  COMMON_SEAT_TYPES_NAME,
} from "../../../lib/constants";

/**
 * 一般席かどうかを判定する
 * @param {string} seatName - 座席名
 * @returns {boolean}
 */
const isGeneralSeat = (seatName) => seatName === COMMON_SEAT_TYPES_NAME.GENERAL;

/**
 * 一般席の空き状況を取得する
 * @param {number} seatsAvailableCount - 残席数
 * @returns {string} SEAT_STATUS.FULL | LIMITED | AVAILABLE
 */
const getGeneralSeatStatus = (seatsAvailableCount) => {
  if (seatsAvailableCount === GENERAL_SEAT_COUNT_THRESHOLDS.MIN) {
    return SEAT_STATUS.FULL;
  }
  if (seatsAvailableCount < GENERAL_SEAT_COUNT_THRESHOLDS.AVAILABLE_MIN) {
    return SEAT_STATUS.LIMITED;
  }
  return SEAT_STATUS.AVAILABLE;
};

/**
 * 一般席以外の空き状況を取得する
 * @param {number} seatsAvailableCount - 残席数
 * @returns {string} SEAT_STATUS.FULL | AVAILABLE
 */
const getNotGeneralSeatStatus = (seatsAvailableCount) => {
  const isFull =
    seatsAvailableCount === NOT_GENERAL_SEAT_COUNT_THRESHOLDS.FORCED_FULL ||
    seatsAvailableCount <= NOT_GENERAL_SEAT_COUNT_THRESHOLDS.MIN;
  if (isFull) {
    return SEAT_STATUS.FULL;
  }
  return SEAT_STATUS.AVAILABLE;
};

/**
 * 座席のステータスを取得する
 * @param {number} seatsAvailableCount - 残席数
 * @param {string} seatName - 座席名
 * @returns {string} SEAT_STATUS.FULL | LIMITED | AVAILABLE
 */
export const getSeatStatus = (seatsAvailableCount, seatName) => {
  if (isGeneralSeat(seatName)) {
    return getGeneralSeatStatus(seatsAvailableCount);
  }
  return getNotGeneralSeatStatus(seatsAvailableCount);
};
